module.exports = __webpack_public_path__ + "static/img/tooltip-attitude.f97c136.png";